// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".point-load-error[data-v-c8600040]{align-items:center;display:flex;flex-direction:column;height:200px;justify-content:center}.point-load-error>label[data-v-c8600040]{font-size:18px}", ""]);
// Exports
module.exports = exports;
